<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <section id="hero" class="rod-section relative pt-32 lg:pt-40 overflow-hidden" style="min-height: 100vh;">
    <div class="rod-aurora" />
    <div class="absolute inset-0 rod-grid-bg" />

    <div class="rod-container grid lg:grid-cols-[1.05fr_0.95fr] gap-12 lg:gap-8 items-center relative">
      <!-- Copy -->
      <div data-reveal>
        <div class="rod-eyebrow mb-6">✦ {{ t('hero.eyebrow') }}</div>

        <h1 class="rod-h1 mb-6">
          <span class="rod-gradient-text">{{ t('hero.title1') }}</span><br>
          <span class="rod-gradient-text">{{ t('hero.title2') }}</span><br>
          <span class="rod-gradient-text">{{ t('hero.title3') }}</span><br>
          <span class="text-white/95">{{ t('hero.titleEnd') }}</span>
        </h1>

        <p class="text-lg lg:text-xl text-[var(--color-text-muted)] max-w-2xl mb-10 leading-relaxed">
          {{ t('hero.lead') }}
        </p>

        <div class="flex flex-wrap gap-4 mb-8">
          <a href="#cta" class="rod-btn-primary">
            {{ t('hero.ctaCustomer') }}
            <span aria-hidden="true">→</span>
          </a>
          <a href="#earnings" class="rod-btn-secondary">
            {{ t('hero.ctaCourier') }}
          </a>
        </div>

        <div class="flex items-center gap-2 text-sm text-[var(--color-text-dim)]">
          <span class="inline-block w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
          <span>{{ t('hero.trust') }}</span>
        </div>
      </div>

      <!-- Phone + floating chips -->
      <div class="relative h-[640px] lg:h-[700px] flex items-center justify-center">
        <div class="rod-chip-float" style="top: 12%; left: -4%;" data-reveal>
          <span class="chip-icon">📱</span>
          <span><strong>{{ t('chips.iphone') }}</strong></span>
        </div>
        <div class="rod-chip-float rod-chip-float--alt" style="top: 30%; right: -8%; animation-delay: -2s;" data-reveal>
          <span class="chip-icon">💼</span>
          <span><strong>{{ t('chips.earnings') }}</strong></span>
        </div>
        <div class="rod-chip-float" style="bottom: 28%; left: -10%; animation-delay: -5s;" data-reveal>
          <span class="chip-icon">🧴</span>
          <span><strong>{{ t('chips.perfume') }}</strong></span>
        </div>
        <div class="rod-chip-float" style="bottom: 10%; right: -2%; animation-delay: -7s;" data-reveal>
          <span class="chip-icon">💻</span>
          <span><strong>{{ t('chips.macbook') }}</strong></span>
        </div>

        <PhoneFrame tilt="center" :parallax="true" :floaty="true">
          <AppScreensRoutePicker />
        </PhoneFrame>
      </div>
    </div>
  </section>
</template>
